import { render } from "./MatchdayTakeover.vue?vue&type=template&id=54c2acc5&scoped=true"
import script from "./MatchdayTakeover.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeover.vue?vue&type=script&lang=js"

import "./MatchdayTakeover.vue?vue&type=style&index=0&id=54c2acc5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c2acc5"]])

export default __exports__